export default __webpack_public_path__ + "static/media/sort-arrows.3fd0b4d1.svg";